/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Skiptocontent2Inputs */

const en_skiptocontent2 = /** @type {(inputs: Skiptocontent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to content`)
};

const pt_skiptocontent2 = /** @type {(inputs: Skiptocontent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar para o conteúdo`)
};

/**
* | output |
* | --- |
* | "Skip to content" |
*
* @param {Skiptocontent2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const skiptocontent2 = /** @type {((inputs?: Skiptocontent2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Skiptocontent2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_skiptocontent2(inputs)
	return pt_skiptocontent2(inputs)
});
export { skiptocontent2 as "skipToContent" }